/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { getActiveCards } from '../../../redux/action/card';
import timeSince from '../../../utils/timesince';

function Analytics() {
  const navigate = useNavigate();
  // const token = localStorage.getItem('userId') //omitting due to eslint warning

  const dispatch = useDispatch()

  // omitting due to eslint warning
  // const handleAnalytics = () => {
  //   navigate('/analytics/overview')
  // }

  const cards = useSelector((state: any) => state.Card?.ActiveCard)

  useEffect(() => {
    dispatch(getActiveCards())
  }, [])

  return (
    <div className='row w-100'>
      {/* <div
        className='col-12 col-md-4 col-lg-4'
        onClick={() => handleAnalytics()}
        style={{ cursor: 'pointer' }}
      >
        <div className='w-100 border rounded shadow-sm p-2'>
          <div className='d-flex justify-content-end mb-5'>
            <svg
              width='45'
              height='22'
              viewBox='0 0 45 22'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect width='45' height='22' rx='11' fill='black' fill-opacity='0.4' />
              <path
                d='M11.299 16V6.77H12.391V14.934H17.019V16H11.299ZM18.7363 9.11H19.8023V16H18.7363V9.11ZM18.7103 8.031V6.796H19.8283V8.031H18.7103ZM27.5627 9.11L25.0407 16H23.7147L21.1927 9.11H22.3367L24.3777 14.882L26.4187 9.11H27.5627ZM28.132 12.555C28.132 10.371 29.367 8.954 31.278 8.954C32.812 8.954 34.151 9.981 34.268 12.412L34.281 12.893H29.263C29.367 14.31 30.082 15.142 31.278 15.142C32.032 15.142 32.708 14.7 33.02 13.972L34.164 14.05C33.761 15.35 32.604 16.156 31.278 16.156C29.367 16.156 28.132 14.739 28.132 12.555ZM29.289 11.944H33.111C32.916 10.488 32.136 9.968 31.278 9.968C30.173 9.968 29.458 10.696 29.289 11.944Z'
                fill='white'
              />
            </svg>
          </div>
          <div className='p-10 d-flex flex-column align-items-center  justify-content-end  pt-5'>
            <svg
              width='62'
              height='57'
              viewBox='0 0 62 57'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M60.0016 50.7288C60.0016 52.9379 58.2108 54.7288 56.0016 54.7288H6C3.79087 54.7288 2 52.9379 2 50.7288V6C2 3.79086 3.79086 2 6 2H56.0016C58.2108 2 60.0016 3.79086 60.0016 6V50.7288Z'
                fill='url(#paint0_linear_787_19872)'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M41.5498 28.3652V54.7296'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M41.5498 2V17.8186'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M46.7354 23.4268L59.9993 31.0065'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M2 36.2843L15.1822 25.7386L25.7279 33.6479L36.5532 24.626'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <defs>
                <linearGradient
                  id='paint0_linear_787_19872'
                  x1='31'
                  y1='-5.5'
                  x2='31.0008'
                  y2='54.7288'
                  gradientUnits='userSpaceOnUse'
                >
                  <stop stop-color='#58A5FF' />
                  <stop offset='1' stop-color='#E0F3FE' stop-opacity='0' />
                </linearGradient>
              </defs>
            </svg>

            <div className='text-center my-4 font-dark1'>Butterfly Flower</div>
            <div style={{ fontSize: '11px' }} className='font-gray1 mb-4'>
              Last updated: 2 mins ago
            </div>
          </div>
        </div>
      </div>
      <div
        className='col-12 col-md-4 col-lg-4'
        onClick={() => handleAnalytics()}
        style={{ cursor: 'pointer' }}
      >
        <div className='w-100 border rounded shadow-sm p-2'>
          <div className='d-flex justify-content-end mb-5'>
            <svg
              width='82'
              height='22'
              viewBox='0 0 82 22'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect width='82' height='22' rx='11' fill='black' fill-opacity='0.4' />
              <path
                d='M11.467 6.77H12.988L17.564 14.713V6.77H18.656V16H17.07L12.559 8.187V16H11.467V6.77ZM23.3591 16.156C21.4481 16.156 20.2131 14.739 20.2131 12.555C20.2131 10.371 21.4481 8.954 23.3591 8.954C25.2701 8.954 26.5051 10.371 26.5051 12.555C26.5051 14.739 25.2701 16.156 23.3591 16.156ZM21.3311 12.555C21.3311 14.167 22.0721 15.142 23.3591 15.142C24.6331 15.142 25.3871 14.167 25.3871 12.555C25.3871 10.943 24.6331 9.968 23.3591 9.968C22.0721 9.968 21.3311 10.943 21.3311 12.555ZM28.5181 7.55H29.5841V9.11H31.4171V10.059H29.5841V14.18C29.5841 14.765 29.8701 15.051 30.4161 15.051H31.4041V16H30.4161C29.1941 16 28.5181 15.35 28.5181 14.18V10.059H27.5041V9.11H28.5181V7.55ZM35.8945 11.138C36.1675 9.799 37.2335 8.954 38.7025 8.954C40.4835 8.954 41.4715 9.994 41.4715 11.84V14.609C41.4715 14.921 41.6015 15.051 41.9005 15.051H42.1735V16H41.7185C41.0165 16 40.4055 15.766 40.4185 14.921C40.1195 15.571 39.3395 16.156 38.2475 16.156C36.8825 16.156 35.7775 15.428 35.7775 14.206C35.7775 12.789 36.8565 12.425 38.3645 12.126L40.4055 11.736C40.3925 10.54 39.8335 9.968 38.7025 9.968C37.8185 9.968 37.2335 10.423 37.0255 11.229L35.8945 11.138ZM36.8955 14.206C36.8955 14.765 37.3765 15.22 38.3905 15.207C39.5345 15.207 40.4315 14.401 40.4315 12.802V12.685L38.7805 12.971C37.7535 13.153 36.8955 13.231 36.8955 14.206ZM48.0034 11.411C47.8474 10.501 47.1064 9.968 46.2614 9.968C44.9744 9.968 44.2334 10.943 44.2334 12.555C44.2334 14.167 44.9744 15.142 46.2614 15.142C47.1454 15.142 47.8994 14.557 48.0554 13.569L49.1864 13.634C48.9654 15.194 47.7304 16.156 46.2614 16.156C44.3504 16.156 43.1154 14.739 43.1154 12.555C43.1154 10.371 44.3504 8.954 46.2614 8.954C47.6784 8.954 48.9394 9.864 49.1214 11.333L48.0034 11.411ZM51.065 7.55H52.131V9.11H53.964V10.059H52.131V14.18C52.131 14.765 52.417 15.051 52.963 15.051H53.951V16H52.963C51.741 16 51.065 15.35 51.065 14.18V10.059H50.051V9.11H51.065V7.55ZM55.5684 9.11H56.6344V16H55.5684V9.11ZM55.5424 8.031V6.796H56.6604V8.031H55.5424ZM64.3948 9.11L61.8728 16H60.5468L58.0248 9.11H59.1688L61.2098 14.882L63.2508 9.11H64.3948ZM64.964 12.555C64.964 10.371 66.199 8.954 68.11 8.954C69.644 8.954 70.983 9.981 71.1 12.412L71.113 12.893H66.095C66.199 14.31 66.914 15.142 68.11 15.142C68.864 15.142 69.54 14.7 69.852 13.972L70.996 14.05C70.593 15.35 69.436 16.156 68.11 16.156C66.199 16.156 64.964 14.739 64.964 12.555ZM66.121 11.944H69.943C69.748 10.488 68.968 9.968 68.11 9.968C67.005 9.968 66.29 10.696 66.121 11.944Z'
                fill='white'
              />
            </svg>
          </div>
          <div className='p-10 d-flex flex-column align-items-center  justify-content-end '>
            <svg
              width='62'
              height='57'
              viewBox='0 0 62 57'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M60.0016 50.7288C60.0016 52.9379 58.2108 54.7288 56.0016 54.7288H6C3.79087 54.7288 2 52.9379 2 50.7288V6C2 3.79086 3.79086 2 6 2H56.0016C58.2108 2 60.0016 3.79086 60.0016 6V50.7288Z'
                fill='url(#paint0_linear_787_19890)'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M41.5498 28.3652V54.7296'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M41.5498 2V17.8186'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M46.7354 23.4268L59.9993 31.0065'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M2 36.2843L15.1822 25.7386L25.7279 33.6479L36.5532 24.626'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M36.2773 23.102C36.2773 20.1887 38.637 17.8291 41.5502 17.8291C44.4635 17.8291 46.8231 20.1887 46.8231 23.102C46.8231 26.0152 44.4635 28.3749 41.5502 28.3749C38.637 28.3749 36.2773 26.0152 36.2773 23.102Z'
                fill='white'
                stroke='#0069E3'
                stroke-width='3'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <defs>
                <linearGradient
                  id='paint0_linear_787_19890'
                  x1='31'
                  y1='-5.5'
                  x2='31.0008'
                  y2='54.7288'
                  gradientUnits='userSpaceOnUse'
                >
                  <stop stop-color='#58A5FF' />
                  <stop offset='1' stop-color='#E0F3FE' stop-opacity='0' />
                </linearGradient>
              </defs>
            </svg>

            <div className='text-center my-4 font-dark1'>Janet Hoshino</div>
            <div style={{ fontSize: '11px' }} className='font-gray1 '>
              Last updated: 2 mins ago
            </div>
          </div>
        </div>
      </div> */}
      {cards?.map((e) => {
        if ('fullImageUrl' in e) {
          return (
            <>
              <React.Fragment>
                <div className='col-12 col-md-4 col-lg-3'>
                  <div className='w-100 h-250px position-relative border rounded  d-flex flex-column justify-content-center align-items-center'>
                    <div>
                      <img
                        onClick={() => navigate(`/analytics/overview/${e._id}`)}
                        style={{ filter: 'drop-shadow(5px 5px 4px #222222)' }}
                        className='h-100 w-100'
                        src={e.fullImageUrl}
                        alt=''
                      />
                      <div style={{ top: '6px', left: '6px' }} className='position-absolute'>
                        {
                          e?.protected?.isActive ?
                            <svg
                              width='45'
                              height='22'
                              viewBox='0 0 45 22'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <rect width='45' height='22' rx='11' fill='black' fill-opacity='0.4' />
                              <path
                                d='M11.299 16V6.77H12.391V14.934H17.019V16H11.299ZM18.7363 9.11H19.8023V16H18.7363V9.11ZM18.7103 8.031V6.796H19.8283V8.031H18.7103ZM27.5627 9.11L25.0407 16H23.7147L21.1927 9.11H22.3367L24.3777 14.882L26.4187 9.11H27.5627ZM28.132 12.555C28.132 10.371 29.367 8.954 31.278 8.954C32.812 8.954 34.151 9.981 34.268 12.412L34.281 12.893H29.263C29.367 14.31 30.082 15.142 31.278 15.142C32.032 15.142 32.708 14.7 33.02 13.972L34.164 14.05C33.761 15.35 32.604 16.156 31.278 16.156C29.367 16.156 28.132 14.739 28.132 12.555ZM29.289 11.944H33.111C32.916 10.488 32.136 9.968 31.278 9.968C30.173 9.968 29.458 10.696 29.289 11.944Z'
                                fill='white'
                              />
                            </svg>
                            :
                            <svg width="82" height="22" viewBox="0 0 82 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="82" height="22" rx="11" fill="black" fill-opacity="0.4" />
                              <path d="M11.467 6.77H12.988L17.564 14.713V6.77H18.656V16H17.07L12.559 8.187V16H11.467V6.77ZM23.3591 16.156C21.4481 16.156 20.2131 14.739 20.2131 12.555C20.2131 10.371 21.4481 8.954 23.3591 8.954C25.2701 8.954 26.5051 10.371 26.5051 12.555C26.5051 14.739 25.2701 16.156 23.3591 16.156ZM21.3311 12.555C21.3311 14.167 22.0721 15.142 23.3591 15.142C24.6331 15.142 25.3871 14.167 25.3871 12.555C25.3871 10.943 24.6331 9.968 23.3591 9.968C22.0721 9.968 21.3311 10.943 21.3311 12.555ZM28.5181 7.55H29.5841V9.11H31.4171V10.059H29.5841V14.18C29.5841 14.765 29.8701 15.051 30.4161 15.051H31.4041V16H30.4161C29.1941 16 28.5181 15.35 28.5181 14.18V10.059H27.5041V9.11H28.5181V7.55ZM35.8945 11.138C36.1675 9.799 37.2335 8.954 38.7025 8.954C40.4835 8.954 41.4715 9.994 41.4715 11.84V14.609C41.4715 14.921 41.6015 15.051 41.9005 15.051H42.1735V16H41.7185C41.0165 16 40.4055 15.766 40.4185 14.921C40.1195 15.571 39.3395 16.156 38.2475 16.156C36.8825 16.156 35.7775 15.428 35.7775 14.206C35.7775 12.789 36.8565 12.425 38.3645 12.126L40.4055 11.736C40.3925 10.54 39.8335 9.968 38.7025 9.968C37.8185 9.968 37.2335 10.423 37.0255 11.229L35.8945 11.138ZM36.8955 14.206C36.8955 14.765 37.3765 15.22 38.3905 15.207C39.5345 15.207 40.4315 14.401 40.4315 12.802V12.685L38.7805 12.971C37.7535 13.153 36.8955 13.231 36.8955 14.206ZM48.0034 11.411C47.8474 10.501 47.1064 9.968 46.2614 9.968C44.9744 9.968 44.2334 10.943 44.2334 12.555C44.2334 14.167 44.9744 15.142 46.2614 15.142C47.1454 15.142 47.8994 14.557 48.0554 13.569L49.1864 13.634C48.9654 15.194 47.7304 16.156 46.2614 16.156C44.3504 16.156 43.1154 14.739 43.1154 12.555C43.1154 10.371 44.3504 8.954 46.2614 8.954C47.6784 8.954 48.9394 9.864 49.1214 11.333L48.0034 11.411ZM51.065 7.55H52.131V9.11H53.964V10.059H52.131V14.18C52.131 14.765 52.417 15.051 52.963 15.051H53.951V16H52.963C51.741 16 51.065 15.35 51.065 14.18V10.059H50.051V9.11H51.065V7.55ZM55.5684 9.11H56.6344V16H55.5684V9.11ZM55.5424 8.031V6.796H56.6604V8.031H55.5424ZM64.3948 9.11L61.8728 16H60.5468L58.0248 9.11H59.1688L61.2098 14.882L63.2508 9.11H64.3948ZM64.964 12.555C64.964 10.371 66.199 8.954 68.11 8.954C69.644 8.954 70.983 9.981 71.1 12.412L71.113 12.893H66.095C66.199 14.31 66.914 15.142 68.11 15.142C68.864 15.142 69.54 14.7 69.852 13.972L70.996 14.05C70.593 15.35 69.436 16.156 68.11 16.156C66.199 16.156 64.964 14.739 64.964 12.555ZM66.121 11.944H69.943C69.748 10.488 68.968 9.968 68.11 9.968C67.005 9.968 66.29 10.696 66.121 11.944Z" fill="white" />
                            </svg>
                        }
                      </div>
                      {/* <div style={{ top: '6px', right: '1px' }} className='position-absolute drop-arrow-hide'>
                        <button className="bg-transparent border-0 dropdown-toggle dropdown-toggle-split more-hover" data-bs-toggle="dropdown" aria-expanded="false">
                          <div className="svg-container">
                            <svg className="svg-icon" width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.599609 2.00002C0.599609 1.1162 1.31578 0.400024 2.19961 0.400024C3.08344 0.400024 3.79961 1.1162 3.79961 2.00002C3.79961 2.88385 3.08344 3.60002 2.19961 3.60002C1.31578 3.60002 0.599609 2.88385 0.599609 2.00002Z" fill="#444444" />
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.39941 2.00002C7.39941 1.1162 8.11559 0.400024 8.99941 0.400024C9.88324 0.400024 10.5994 1.1162 10.5994 2.00002C10.5994 2.88385 9.88324 3.60002 8.99941 3.60002C8.11559 3.60002 7.39941 2.88385 7.39941 2.00002Z" fill="#444444" />
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1992 2.00002C14.1992 1.1162 14.9154 0.400024 15.7992 0.400024C16.683 0.400024 17.3992 1.1162 17.3992 2.00002C17.3992 2.88385 16.683 3.60002 15.7992 3.60002C14.9154 3.60002 14.1992 2.88385 14.1992 2.00002Z" fill="#444444" />
                            </svg>

                            <svg className="overlay-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="15" cy="15" r="15" fill="black" fill-opacity="0" />
                            </svg>
                          </div>
                        </button>
                        <ul className="dropdown-menu p-4 mt-3 w-100 px-3">
                          <li className='cursor-pointer' onClick={() => handleOpen(e?._id)}>
                            <div className='d-flex gap-2 align-items-center'>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0922 3.54529V15H2.91016V3.54529" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1 3.54529H15.0002" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 7.36389V11.1821" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.45508 7.36389V11.1821" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10.5449 7.36389V11.1821" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.45508 3.5455V1H10.5461V3.5455" stroke="#F74545" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                              Delete
                            </div>
                          </li>
                          <li className='pt-2 cursor-pointer' onClick={() => navigate(`/analytics/overview/${e._id}`)}>
                            <div className='d-flex gap-2 align-items-center' style={{ width: "max-content" }}>
                              <svg width="16" height="16" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" ><path d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" /></svg>
                              View Analytics
                            </div>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '11px' }} className='my-2 font-gray1'>
                      {timeSince(e.updatedAt)}
                    </div>
                  </div>
                </div>
              </React.Fragment >
            </>
          )
        }
        else return <></>
      })}

    </div>
  )
}

export default Analytics
